<div class="blog-post">
    <div *ngIf="notFound" class="rana-panel">
        <h2 class="mb-3">Post not found</h2>
        <a routerLink="/blogs">Back to all blogs</a>
    </div>

    <ng-container *ngIf="blog">
        <a routerLink="/blogs" class="small d-inline-block mb-2">&larr; All blogs</a>

        <!-- The post -->
        <article class="rana-panel blog-article">
            <h2 class="mb-2 blog-title">{{ blog.title }}</h2>
            <p class="text-muted mb-4">
                <a [routerLink]="['/members', blog.authorId]">{{ blog.authorName }}</a> · {{ blog.createdAtEpoch | date:'longDate' }} · {{ blog.category | titlecase }}
            </p>

            <div *ngIf="blog.status === 'HIDDEN'" class="alert alert-warning">
                This post is hidden from the feed.
                <span *ngIf="blog.hiddenReason">Reason: {{ blog.hiddenReason }}</span>
            </div>

            <div class="section img-wrap border-4 over-hide mb-4" *ngIf="blog.coverImageUri">
                <img [src]="blog.coverImageUri" alt=""/>
            </div>

            <div class="blog-body mb-4" [innerHTML]="body"></div>

            <div class="d-flex align-items-center flex-wrap">
                <button class="rana-action-btn mr-2" [ngClass]="{'rana-action-btn-active': blog.likedByMe}"
                        (click)="toggleLike()">
                    <i class="uil uil-heart"></i> {{ blog.likedByMe ? 'Liked' : 'Like' }} · {{ blog.likeCount }}
                </button>
                <a *ngIf="blog.canEdit" class="rana-action-btn mr-2"
                   [routerLink]="['/blogs', blog.blogId, 'edit']">Edit</a>
                <button *ngIf="blog.canModerate" class="rana-action-btn mr-2" (click)="toggleHidden()">
                    {{ blog.status === 'PUBLISHED' ? 'Hide post' : 'Unhide post' }}
                </button>
                <button *ngIf="blog.canEdit || blog.canModerate" class="rana-action-btn rana-action-btn-danger"
                        (click)="deleteBlog()">Delete
                </button>
            </div>
        </article>

        <!-- Comments -->
        <section class="rana-panel mt-4">
            <h5 class="mb-3 blog-heading">Comments ({{ blog.commentCount }})</h5>
            <div *ngFor="let c of comments" class="media mb-3">
                <img *ngIf="avatars[c.userId] as src" [src]="src" class="blog-avatar mr-3" alt="">
                <span *ngIf="!avatars[c.userId]" class="blog-avatar blog-avatar-initials mr-3">{{ initials(c.userName) }}</span>
                <div class="media-body">
                    <div class="font-weight-500"><a [routerLink]="['/members', c.userId]">{{ c.userName }}</a>
                        <small class="text-muted ml-2">{{ c.createdAtEpoch | date:'medium' }}</small>
                        <a *ngIf="c.canDelete" href="javascript:" class="ml-2 small text-danger"
                           (click)="deleteComment(c)">delete</a>
                    </div>
                    <p class="mb-0 blog-comment-text">{{ c.text }}</p>
                </div>
            </div>
            <p *ngIf="comments.length === 0" class="text-muted">No comments yet.</p>

            <div class="mt-4">
                <h5 class="mb-2">Leave a comment</h5>
                <ng-container *ngIf="loggedIn; else loginPrompt">
                    <textarea class="form-control mb-2" rows="3" maxlength="1000" [(ngModel)]="newComment"
                              placeholder="Write your comment"></textarea>
                    <button class="btn btn-dark-primary" [disabled]="!newComment.trim()"
                            (click)="postComment()">Post comment
                    </button>
                </ng-container>
                <ng-template #loginPrompt>
                    <p><a routerLink="/login">Log in</a> to like or comment.</p>
                </ng-template>
            </div>
        </section>
    </ng-container>
</div>
